const TOKEN_KEY = 'token';
const TOKEN_STORAGE_KEY = 'token_storage';

export const getToken = () => {
	const storageType = localStorage.getItem(TOKEN_STORAGE_KEY);

	if (storageType === 'session') {
		return sessionStorage.getItem(TOKEN_KEY);
	}

	const localToken = localStorage.getItem(TOKEN_KEY);
	if (localToken) {
		return localToken;
	}

	return sessionStorage.getItem(TOKEN_KEY);
};

export const setToken = (token, options = {}) => {
	const remember = options.remember !== false;

	clearToken();

	if (remember) {
		localStorage.setItem(TOKEN_KEY, token);
		localStorage.setItem(TOKEN_STORAGE_KEY, 'local');
		return;
	}

	sessionStorage.setItem(TOKEN_KEY, token);
	localStorage.setItem(TOKEN_STORAGE_KEY, 'session');
};

export const clearToken = () => {
	localStorage.removeItem(TOKEN_KEY);
	sessionStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(TOKEN_STORAGE_KEY);
};
